import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../../components/ProgressCom";
import CustomPagination from "../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseDiscountCode } from "./UseDiscountCode";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import BrandSearchCom from "../../../basic-information/brand/BrandSearchCom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";

export default function CodeBrand(props) {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    getDiscountCodeBrand,
    addDiscountCodeBrand,
    deleteDiscountCodeBrand,
  } = UseDiscountCode();
  const [brands, setBrands] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [name, setName] = useState("");
  const [addBrand, setAddBrand] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    discountID: props.DiscountID,
    brandID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (props.DiscountID) {
      setProgress(true);
      getDiscountCodeBrand(props.DiscountID, (callback) => {
        setBrands(callback);
      });
    }
  }, [props.DiscountID]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "brandName",
      width: 180,
      align: "center",
      headerName: "نام برند",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.brandName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.brandID,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addBrand",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              // setScrollTo(undefined);
              location.state = null;
              setAddBrand(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      open={props.showBrands}
      onClose={() => props.setShowBrands(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addBrand ? (
            <Typography color="secondary" variant="subtitle2">
              لیست برندها
            </Typography>
          ) : (
            <Typography variant="subtitle2">برند را انتخاب کنید</Typography>
          )}
          {!addBrand ? (
            <IconButton
              onClick={() => {
                props.setShowBrands(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setAddBrand(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addBrand ? (
          <Box sx={{ height: "18rem" }}>
            {brands ? (
              <DataGrid
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={brands ? brands : []}
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={brands && brands.length ? brands.length : 1}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    nofab: true,
                    noPageCount: true,
                    rowCount: brands && brands.length ? brands.length : "",
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "id",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
            }}
          >
            <BrandSearchCom
              setName={setName}
              selectedBrandID={stateAdd.brandID}
              setter={setStateAdd}
              lvl1State={stateAdd}
            ></BrandSearchCom>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.brandID) {
                    enqueueSnackbar("برند را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  addDiscountCodeBrand(stateAdd, () => {
                    setProgress(true);
                    getDiscountCodeBrand(stateAdd.discountID, (callback) => {
                      setBrands(callback);
                    });
                    props.callback(props.DiscountID);
                    setAddBrand(false);
                    setStateAdd({ ...stateAdd, brandID: "" });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.brandID) {
                      enqueueSnackbar("برند را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    addDiscountCodeBrand(stateAdd, () => {
                      setProgress(true);
                      getDiscountCodeBrand(stateAdd.discountID, (callback) => {
                        setBrands(callback);
                      });
                      props.callback(props.DiscountID);
                      setAddBrand(false);
                      setStateAdd({ ...stateAdd, brandID: "" });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShowBrands(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"برند"}
          callback={() => {
            setProgress(true);
            deleteDiscountCodeBrand(deleteState.id, () => {
              getDiscountCodeBrand(props.DiscountID, (callback) => {
                props.callback(props.DiscountID);
                setBrands(callback);
              });
            });
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
